module.exports = __webpack_public_path__ + "img/user-screen.a3259907.svg";